// extracted by extract-css-chunks-webpack-plugin
module.exports = {"socialLink":"SocialLinks__socialLink__1KI-B"};